import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Badge } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import EMMSectionHeader from './EMMSectionHeader';
import { useAccount } from '../contexts/AccountContext';

const CreateCampaign = () => {
  const { selectedAccount, isAllAccountsSelected } = useAccount();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      // TODO: Implement campaign creation with Amazon SES - ACCOUNT SPECIFIC
      // Include selectedAccount.id in the API call
      const campaignData = {
        ...data,
        accountId: selectedAccount.id !== 'all' ? selectedAccount.id : null
      };
      console.log('Campaign data:', campaignData);
      
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      toast.success(`Campaign created successfully for ${selectedAccount?.alias || 'selected account'}!`);
    } catch (error) {
      toast.error('Failed to create campaign');
      console.error('Error creating campaign:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <EMMSectionHeader title="Create New Campaign" backTo="/campaigns" showHelp />
      <Container className="mt-3">
      <Row>
        <Col>
          <p className="text-muted mb-0">
            {isAllAccountsSelected 
              ? 'Create and send email campaigns using Amazon SES'
              : `Create and send email campaigns for ${selectedAccount?.alias || 'selected account'} using Amazon SES`
            }
          </p>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col md={8}>
          <Card>
            <Card.Header>
              <h5>Campaign Details</h5>
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Campaign Name *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter campaign name"
                        {...register('name', { required: 'Campaign name is required' })}
                        isInvalid={errors.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Subject Line *</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter email subject"
                        {...register('subject', { required: 'Subject line is required' })}
                        isInvalid={errors.subject}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.subject?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group className="mb-3">
                  <Form.Label>From Email *</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="sender@example.com"
                    {...register('fromEmail', { 
                      required: 'From email is required',
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: 'Invalid email address'
                      }
                    })}
                    isInvalid={errors.fromEmail}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.fromEmail?.message}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>From Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Your Company Name"
                    {...register('fromName')}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email Content *</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={10}
                    placeholder="Enter your email content here..."
                    {...register('content', { required: 'Email content is required' })}
                    isInvalid={errors.content}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.content?.message}
                  </Form.Control.Feedback>
                </Form.Group>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Send Date</Form.Label>
                      <Form.Control
                        type="datetime-local"
                        {...register('sendDate')}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Recipients</Form.Label>
                      <Form.Select {...register('recipients')}>
                        <option value="all">All Subscribers</option>
                        <option value="segment1">Segment 1</option>
                        <option value="segment2">Segment 2</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex gap-2">
                  <Button type="submit" variant="primary" disabled={isSubmitting}>
                    {isSubmitting ? 'Creating...' : 'Create Campaign'}
                  </Button>
                  <Button type="button" variant="outline-secondary">
                    Save as Draft
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card>
            <Card.Header>
              <h5>Campaign Preview</h5>
            </Card.Header>
            <Card.Body>
              <div className="border p-3 bg-light">
                <small className="text-muted">Preview will appear here</small>
              </div>
            </Card.Body>
          </Card>

          <Card className="mt-3">
            <Card.Header>
              <h5>Amazon SES Status</h5>
            </Card.Header>
            <Card.Body>
              <Alert variant="success">
                <strong>Connected</strong><br />
                <small>Amazon SES is properly configured</small>
              </Alert>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
    </>
  );
};

export default CreateCampaign;

